import { RandomInteger } from "./RandomInteger"

export function* RandomChoice<T>(
  n: number,
  choices: T[],
  seed: number
): IterableIterator<T> {
  // Generate random indices in the range [0, choices.length - 1]
  const indices = RandomInteger(n, 0, choices.length - 1, seed)

  // Map each random index to the corresponding choice
  for (const index of indices) {
    yield choices[index]
  }
}
